import { ChevronDownOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronDownOutlined";
import { Slot } from "../ProductCardSlot";
import styles from "./List.module.scss";
import classNames from "classnames/bind";
import { sendMonetateEvent } from "@~/utils/sendMonetateEvent";
import { ProductCardLayout } from "@~/types/types.ts";
import { useFeatureFlags } from "@~/flags/flags";

const cx = classNames.bind(styles);

export const slotNameMap = {
  IMAGE_BANNER: "image-banner",
  IMAGE: "image",
  HEADER: "header",
  DETAILS_PRIMARY: "details-primary",
  DETAILS_SECONDARY: "details-secondary",
  IMAGE_ACTIONS: "image-actions",
  IMAGE_FOOTER: "image-footer",
  HEADER_ACTIONS: "header-actions",
  ASIDE: "aside",
  FOOTER: "footer",
};

export const List: ProductCardLayout = (props) => {
  const { product, index } = props;
  const flags = useFeatureFlags();

  return (
    <article
      onClick={() => {
        sendMonetateEvent("productCard.interaction");
      }}
      className={styles["card-container"]}
      data-product-card-layout="List"
      data-testid="product-card-layout"
      data-product-id={product?.aliases?.pimProductId}
      id={product?.aliases?.pimProductId} // Needed for wish list scrolling
    >
      <div className={styles["inner-container"]}>
        <div className={styles["left-column"]}>
          <div className={styles["image-container"]}>
            <Slot
              slotName={slotNameMap["IMAGE_BANNER"]}
              className={styles["image-banner-slot"]}
              {...props}
            />
            <Slot
              slotName={slotNameMap["IMAGE"]}
              className={styles["image-slot"]}
              {...props}
            />
            <Slot
              slotName={slotNameMap["IMAGE_ACTIONS"]}
              className={styles["image-actions-slot"]}
              {...props}
            />
          </div>
          <Slot
            slotName={slotNameMap["IMAGE_FOOTER"]}
            className={styles["image-footer-slot"]}
            {...props}
          />
        </div>

        <div className={styles["header-container"]}>
          <Slot
            slotName={slotNameMap["HEADER"]}
            className={styles["header-slot"]}
            {...props}
          />
          <Slot
            slotName={slotNameMap["HEADER_ACTIONS"]}
            className={styles["header-actions-slot"]}
            {...props}
          />
        </div>

        <Slot
          slotName={slotNameMap["ASIDE"]}
          className={styles["aside-slot"]}
          {...props}
        />

        <div className={styles["details-container"]}>
          <Slot
            slotName={slotNameMap["DETAILS_PRIMARY"]}
            className={cx("details-primary-slot")}
            {...props}
          />
          <div
            className={cx("details-accordion", {
              "details-accordion-2col": flags.fullWidth?.value,
            })}
          >
            <button
              data-testid="details-accordion-button"
              aria-expanded={index === 0 ? "true" : "false"}
              aria-controls={`details-accordion-${product?.aliases?.pimProductId}`}
              type="button"
              className={cx("details-accordion-button", {
                "details-accordion-button-2col": flags.fullWidth?.value,
              })}
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                const button = event.currentTarget;
                button.setAttribute(
                  "aria-expanded",
                  button.getAttribute("aria-expanded") === "true"
                    ? "false"
                    : "true",
                );
              }}
            >
              Key specifications:
              <ChevronDownOutlined
                className={styles["details-accordion-icon"]}
                size="medium"
              />
            </button>
            <Slot
              slotName={slotNameMap["DETAILS_SECONDARY"]}
              id={`details-accordion-${product?.aliases?.pimProductId}`}
              className={cx(
                "details-secondary-slot",
                "details-accordion-panel",
              )}
              {...props}
            />
          </div>
        </div>
        <Slot
          slotName={slotNameMap["FOOTER"]}
          className={styles["footer-slot"]}
          {...props}
        />
      </div>
    </article>
  );
};
